import {useEffect, useState} from "react";
import axios from "axios";
import {COURSE_API_BASE} from "../utils/apiConfig";
import {sanitizeLessonContent} from "../utils/commonUtils";

/**
 * Fetches a single course content item (lesson / project / video).
 * Lesson content is sanitized before being returned.
 */
const useCourseContent = (courseId, contentId, language) => {
    const [content, setContent] = useState(null);
    const [contentType, setContentType] = useState(null);
    // Whether the learner already finished this content (backend: course_level >= content.level)
    const [alreadyCompleted, setAlreadyCompleted] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!courseId || !contentId) return;

        // Ignore responses that arrive after params changed or the component unmounted
        let isCancelled = false;

        const fetchContent = async () => {
            try {
                setLoading(true);
                setError("");

                const res = await axios.get(
                    `${COURSE_API_BASE}/${courseId}/content/${contentId}`,
                    {
                        params: {language},
                        withCredentials: true,
                    }
                );

                if (isCancelled) return;

                const row = res.data.course.content;
                const type = row.content?.type;

                setContentType(type);
                setAlreadyCompleted(Boolean(row.already_completed));
                setContent(
                    type === "lesson"
                        ? sanitizeLessonContent(row.content)
                        : row.content
                );
            } catch (err) {
                if (isCancelled) return;

                console.error("Content fetch failed:", err);
                console.error("Response:", err.response?.data);
                setError("خطا در دریافت محتوا");
            } finally {
                if (!isCancelled) setLoading(false);
            }
        };

        fetchContent();

        return () => {
            isCancelled = true;
        };
    }, [courseId, contentId, language]);

    return {content, contentType, alreadyCompleted, loading, error};
};

export default useCourseContent;